import {
  TKwikUIToasterPosition,
  TKwikUIToasterShape,
  TKwikUIToasterSize,
  TKwikUIToasterType,
  VKwikUIToasterPosition,
  VKwikUIToasterShape,
  VKwikUIToasterSize,
  VKwikUIToasterType
} from "./toaster.definitions";

export const isValidKeyValue = (key: string, value: any): boolean => {
  const isString = (x: string) => typeof x === "string";
  const isNumber = (x: number) => typeof x === "number" && !Number.isNaN(x);
  const isNonNegative = (x: number) => isNumber(x) && x >= 0;
  const isObject = (x: any) => typeof x === "object" && x !== null;

  const methods = {
    duration: (x: number) => isNonNegative(x),
    message: isString,
    position: (x: TKwikUIToasterPosition) => VKwikUIToasterPosition.includes(x),
    shape: (x: TKwikUIToasterShape) => VKwikUIToasterShape.includes(x),
    size: (x: TKwikUIToasterSize) => VKwikUIToasterSize.includes(x),
    type: (x: TKwikUIToasterType) => VKwikUIToasterType.includes(x),
    offset: isObject
  };

  return methods[key] && methods[key](value);
};
